import EmailCampaignToken from '@apps/truevail/admin/tokens/email_campaign'
import EntityChooser from '@admin/components/entity_chooser'
import PropTypes from 'prop-types'
import React from 'react'

class Campaigns extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  _handleDone = this._handleDone.bind(this)

  render() {
    return <EntityChooser { ...this._getEntityChooser() } />
  }

  _getEntityChooser() {
    return {
      entity: 'email campaign',
      multiple: true,
      screenshot: (entity) => `truevail_email_campaign_variants/${entity.variants[0].code}`,
      search: {
        endpoint: '/api/admin/truevail/library/email_campaigns',
        format: (email_campaign) => (
          <EmailCampaignToken email_campaign={ email_campaign } show_provider={ false }/>
        )  
      },
      showHeader: false,
      onDone: this._handleDone
    }
  }

  _handleDone(email_campaigns) {
    this.props.onNext({ email_campaigns })
  }

}

export default Campaigns
